var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-sr", attrs: { id: "project-sr-" + _vm.srIndex } },
    [
      _c(
        "div",
        { staticClass: "row completion-type" },
        [
          _c("TextField", {
            attrs: {
              label: _vm.$t("project.submission.completionTypeDate"),
              value: _vm.completionMsg,
              readonly: true,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("TextField", {
        attrs: {
          label: _vm.requestLabel,
          value: _vm.submission.completedItems,
          readonly: true,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.showInvoice
            ? _c("InvoiceInfo", {
                attrs: {
                  submission: _vm.submission,
                  srIndex: _vm.srIndex,
                  readonly: true,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("PaidStatus", {
            attrs: {
              submission: _vm.submission,
              isContractor: _vm.isContractor,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("InspectorVue", { attrs: { submission: _vm.submission } }),
          _vm._v(" "),
          _vm.shouldShowPcReleasedPo
            ? _c("ContractReleasedPoVue", {
                attrs: { submission: _vm.submission, srIndex: _vm.srIndex },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("po-balance-calculation", {
        attrs: {
          submission: _vm.submission,
          srIndex: _vm.srIndex,
          readonly: true,
        },
      }),
      _vm._v(" "),
      _vm.showInvoice
        ? _c(
            "div",
            { staticClass: "project-sr-attachment" },
            [
              _c("div", [_c("label", [_vm._v(_vm._s("Invoice"))])]),
              _vm._v(" "),
              _c("EditAttachments", {
                attrs: {
                  sourceId: _vm.submission.invoice.id,
                  canDelete: false,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasAttachments,
              expression: "hasAttachments",
            },
          ],
          staticClass: "project-sr-attachment",
        },
        [
          _c("div", [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("project.submission.supportDocs"))),
            ]),
          ]),
          _vm._v(" "),
          _c("EditAttachments", {
            attrs: {
              sourceId: _vm.submission.id,
              canEdit: _vm.isContractor && _vm.isDraft,
              canDelete: false,
              getFileLengthID: _vm.submission.id,
              canDownloadAll: !_vm.isContractor,
              downloadString: "Download Supporting Doc",
              zipName:
                _vm.currentProject.number + "_Submission_attachments.zip",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row submission-info" },
        [
          _c("TextField", {
            staticClass: "small-3 medium-3 large-3 columns",
            attrs: {
              label: _vm.$t("PIC"),
              value: _vm.personInCharge.name,
              readonly: true,
            },
          }),
          _vm._v(" "),
          _c("TextField", {
            staticClass: "small-3 medium-3 large-3 columns",
            attrs: {
              label: _vm.$t("position"),
              value: _vm.personInCharge.position,
              readonly: true,
            },
          }),
          _vm._v(" "),
          _c("TextField", {
            staticClass: "small-4 medium-4 large-4 columns",
            attrs: {
              label: _vm.$t("onBehalfOf"),
              value: _vm.companyName,
              readonly: true,
            },
          }),
          _vm._v(" "),
          _c("TextField", {
            staticClass: "small-2 medium-2 large-2 columns submitted-on",
            attrs: {
              label: _vm.$t("submittedOn"),
              value: _vm.submittedDate,
              readonly: true,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "project-sr-export clearfix" }, [
        !_vm.isContractor && _vm.isAppr
          ? _c("div", { staticClass: "float-right clearfix" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { type: "button" },
                  on: {
                    click: function () {
                      return _vm.exportPDF()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.generatePDF")))]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.rejectHistory && _vm.rejectHistory.length > 0,
              expression: "rejectHistory && rejectHistory.length > 0",
            },
          ],
          staticClass: "action-history",
        },
        [
          _c("div", [_c("label", [_vm._v(_vm._s(_vm.$t("history")))])]),
          _vm._v(" "),
          _vm._l(_vm.rejectHistory, function (history, index) {
            return _c("reject-history", {
              key: index,
              class: { "odd-row": index % 2 },
              attrs: {
                item: history,
                isContractor: _vm.isContractor,
                showRejectHeader: !index,
              },
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c(
            "HKLViewLayout",
            { attrs: { checkIsRepresentative: true } },
            [
              _c("ProjectRepRemarks", {
                on: {
                  review: function () {
                    var args = [],
                      len = arguments.length
                    while (len--) args[len] = arguments[len]

                    return _vm.review.apply(void 0, args)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPicView
        ? _c("div", { staticClass: "project-sr-approval clearfix" }, [
            !_vm.isContractor && _vm.isOpen
              ? _c("div", { staticClass: "float-right clearfix" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue tender-sticky-button",
                      attrs: { type: "button" },
                      on: {
                        click: function () {
                          return _vm.reject(_vm.submission.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.reject")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--orange tender-sticky-button",
                      attrs: { type: "button" },
                      on: {
                        click: function () {
                          return _vm.beforeAcceptSubmission()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.accept")))]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("FinalPaymentModal", {
        ref: "retFinalPayModal",
        attrs: {
          afterConfirm: _vm.openRateModalInRetention,
          srIndex: _vm.srIndex,
          submission: _vm.submission,
          eventId: _vm.dialogId,
        },
      }),
      _vm._v(" "),
      _vm.isForceRatingSubmission
        ? _c("rate", {
            ref: "rateModal",
            attrs: {
              rateType: _vm.rateCatergory,
              dialogId: _vm.dialogId,
              actionType: _vm.rateActionCatergory,
              sourceId: _vm.submission.id,
              allowEdit: _vm.isOpen,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isContractor && _vm.isOpen
        ? _c(
            "RejectModal",
            { ref: "rejectSrModal", attrs: { id: _vm.rejectModalId } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("p", { staticClass: "modal-pure-text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("project.submission.rejectAlert")) +
                      "\n      "
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "recheckSupportDocModal",
        attrs: {
          title: _vm.$t("project.supportDocument.modelLabel"),
          closable: true,
          hasCancelBtn: true,
          okBtnAction: "yesAccept",
        },
        on: {
          onOkClick: function () {
            return _vm.acceptSubmission()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "HKLModal",
        {
          ref: "checkingHintsModal",
          attrs: {
            title: _vm.$t("project.submission.checkHint.title"),
            closable: true,
            hasCancelBtn: false,
          },
        },
        [
          _c("div", { staticClass: "project-sr__hints" }, [
            _c(
              "ul",
              _vm._l(_vm.checkingHints, function (hint, index) {
                return _c("li", { key: index }, [
                  _vm._v("\n          " + _vm._s(hint) + "\n        "),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("SubmissionInspectorModal", {
        ref: "inspectorModal",
        attrs: {
          submission: _vm.submission,
          nextActionAfterSave: _vm.showPopupOrApprove,
          submissionIndex: _vm.srIndex,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }